import { Link } from 'react-router-dom';
import './EspacoKids.css';

const KIDS_CARDS = [
  {
    title: 'Vocabulário',
    desc:  'Aprenda palavras novas com figurinhas e pronúncia!',
    emoji: '🍎',
    color: '#ff6b6b',
    link:  '/vocabulario',
  },
  {
    title: 'Jogos de Cores',
    desc:  'Descubra as cores em inglês brincando.',
    emoji: '🎨',
    color: '#9b59b6',
    link:  '/color-game',
  },
  {
    title: 'Dicionário Faminto',
    desc:  'Alimente o monstrinho com as palavras certas!',
    emoji: '👾',
    color: '#2ecc71',
    link:  '/dicionario-faminto',
  },
  {
    title: 'Jogos de Perguntas',
    desc:  'Responda e ganhe pontos enquanto aprende.',
    emoji: '❓',
    color: '#1e90ff',
    link:  '/jogo-pergunta',
  },
];

export default function EspacoKids() {
  return (
    <div className="kids-page">
      <Link to="/atividades" className="kids-back-btn">
        <i className="fas fa-arrow-left" /> Voltar às atividades
      </Link>

      <h1 className="kids-title">
        <span role="img" aria-label="estrela">🌟</span> Espaço Kids <span role="img" aria-label="estrela">🌟</span>
      </h1>
      <p className="kids-subtitle">Atividades divertidas para aprender inglês brincando!</p>

      <div className="kids-grid">
        {KIDS_CARDS.map(card => (
          <Link key={card.title} to={card.link} className="kids-card" style={{ '--kids-color': card.color }}>
            <span className="kids-card-emoji">{card.emoji}</span>
            <h3 className="kids-card-title">{card.title}</h3>
            <p className="kids-card-desc">{card.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
